import { FormControl, FormControlProps } from '@jurnee/common/src/components/primitives/FormControl';
import { Input, InputProps } from '@jurnee/common/src/components/primitives/Input';
import { useTranslation } from 'react-i18next';

interface Props extends Omit<FormControlProps, 'children'> {
  name: string;
  value: string | null;
  hasPlaceholder?: boolean;
  hasHelper?: boolean;
  hasErrorMessage?: boolean;
  type?: InputProps['type'];
  size?: InputProps['size'];
  onChange(value: string): void;
}

export function InputFormControl({
  name,
  value,
  hasPlaceholder,
  hasHelper,
  hasErrorMessage,
  type = 'text',
  size = 'sm',
  errorMessage,
  isDisabled,
  onChange,
  ...inheritedProps
}: Props) {
  const { t } = useTranslation('common');

  return (
    <FormControl
      label={t(`fields.${name}.label`)}
      helperText={hasHelper ? t(`fields.${name}.helper`) : undefined}
      errorMessage={errorMessage || (hasErrorMessage ? t(`fields.${name}.error`) : undefined)}
      {...inheritedProps}
    >
      <Input
        type={type}
        name={name}
        value={value ?? ''}
        placeholder={hasPlaceholder ? t(`fields.${name}.placeholder`) : undefined}
        onChange={(e) => onChange(e.target.value)}
        size={size}
        isDisabled={isDisabled}
      />
    </FormControl>
  );
}